/* eslint-disable  */
import React, { useEffect, useState } from "react";
import { TbMessageCircle } from "react-icons/tb";
import { FaChevronDown, FaChevronUp, FaFileAlt, FaUserTie, FaBriefcase, FaShoppingBag, FaIdCard } from "react-icons/fa";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { bindActionCreators } from "redux";
import "../../../css/Pages/Pages.css";
import { userDataActionCreators } from "../../../service/action-creators";
import { GetUserProfile } from "../../../service/action-creators/authAction";
import { GetNotifications } from "../../../service/action-creators/notificationAction";
import Loader from "../../Loader";
import Modal from "../../Modal/Modal";
import NotFoundComponent from "../../NotFoundComponent";
import RenderHome from "../home/RenderHome";
import { ToastContainer, toast } from "react-toastify";

function MyOrdersNdPurchases() {
  const dispatch = useDispatch();
  const history = useHistory();
  const device = () => window.innerWidth < 1080;

  const {
    GetMyOrders,
    GetAppliedOrderDetailed,
    DeleteMyAppliedOrder,
    GetCartProducts,
    ResetUserDataResponse,
  } = bindActionCreators(userDataActionCreators, dispatch);

  const orders = useSelector((state) => state.user?.orders);
  const isLoading = useSelector((state) => state.user?.isLoading);
  const response = useSelector((state) => state?.user?.response);
  const orderDetailed = useSelector((state) => state?.user?.order);
  const user = useSelector((state) => state?.auth?.user);
  const [openMessageModal, setOpenMessageModal] = useState(false);
  const [expandedOrderId, setExpandedOrderId] = useState(null);
  const [messageEditDetailed, setMessageEditDetailed] = useState("");
  const [isMobile, setIsMobile] = useState(device);

  useEffect(() => {
    dispatch(GetUserProfile());
    GetMyOrders();
    dispatch(GetNotifications());
    GetCartProducts();
  }, []);

  useEffect(() => {
    window.addEventListener("resize", () => setIsMobile(device));
    return () => {};
  }, []);

  useEffect(() => {
    if (response?.state === "SUCCESS") {
      toast.success(response?.message);
      GetMyOrders();
      setTimeout(() => ResetUserDataResponse(), 1500);
    } else if (response?.state === "ERROR") {
      toast.error(response?.message);
      setTimeout(() => ResetUserDataResponse(), 1500);
    }
  }, [response?.state]);

  const handleTogglePreview = (orderId) => {
    if (expandedOrderId === orderId) {
      setExpandedOrderId(null);
    } else {
      GetAppliedOrderDetailed(orderId);
      setExpandedOrderId(orderId);
    }
  };

  /* --- Shared inline styles --- */
  const cardStyle = {
    background: "#fff",
    borderRadius: "0.75rem",
    border: "1px solid #e5e7eb",
    marginBottom: "1rem",
    boxShadow: "0 1px 4px rgba(0,0,0,0.06)",
    overflow: "hidden",
  };

  const cardHeader = {
    padding: "1.25rem",
  };

  const statusDot = (active, isRejected) => ({
    width: "14px",
    height: "14px",
    borderRadius: "50%",
    background: active ? (isRejected ? "#ef4444" : "#16a34a") : "#d1d5db",
    flexShrink: 0,
  });

  const statusLine = (active) => ({
    flex: 1,
    height: "3px",
    background: active ? "#16a34a" : "#e5e7eb",
    margin: "0 0.25rem",
  });

  const dropdownBody = {
    borderTop: "1px solid #e5e7eb",
    background: "#fafbfc",
    padding: "1.25rem",
  };

  const sectionTitle = {
    display: "flex",
    alignItems: "center",
    gap: "0.5rem",
    fontSize: "0.95rem",
    fontWeight: 600,
    color: "#1f2937",
    marginBottom: "0.75rem",
    paddingBottom: "0.5rem",
    borderBottom: "1px solid #e5e7eb",
  };

  const fieldRow = {
    display: "grid",
    gridTemplateColumns: isMobile ? "1fr" : "1fr 1fr",
    gap: "0.75rem",
    marginBottom: "0.5rem",
  };

  const fieldRowThree = {
    display: "grid",
    gridTemplateColumns: isMobile ? "1fr 1fr" : "repeat(auto-fit, minmax(140px, 1fr))",
    gap: "0.75rem",
    marginBottom: "0.5rem",
  };

  const fieldLabel = {
    fontSize: "0.7rem",
    color: "#6b7280",
    textTransform: "uppercase",
    letterSpacing: "0.03em",
    marginBottom: "0.15rem",
    fontWeight: 500,
  };

  const fieldValue = {
    fontSize: "0.88rem",
    fontWeight: 600,
    color: "#1f2937",
    wordBreak: "break-word",
  };

  const FieldItem = ({ label, value }) => (
    <div>
      <div style={fieldLabel}>{label}</div>
      <div style={fieldValue}>{value || "N/A"}</div>
    </div>
  );

  const toggleBtnStyle = (isExpanded) => ({
    display: "inline-flex",
    alignItems: "center",
    gap: "0.35rem",
    padding: "0.4rem 0.85rem",
    background: isExpanded ? "#62CA91" : "#058740",
    color: "#fff",
    border: "none",
    borderRadius: "0.4rem",
    cursor: "pointer",
    fontSize: "0.78rem",
    fontWeight: 500,
  });

  const renderStatusTracker = (order) => {
    const stages = [
      { key: "submitted", label: "Submitted" },
      { key: "initiated", label: "Initiated" },
      { key: "approved", label: "Approved" },
      { key: "shipping", label: "Shipped" },
    ];
    const isRejected = order?.rejected?.[0]?.status;

    return (
      <div>
        <div style={{ display: "flex", alignItems: "center", marginBottom: "0.5rem", padding: "0 0.25rem" }}>
          {stages.map((stage, i) => {
            const active = order?.[stage.key]?.[0]?.status;
            return (
              <React.Fragment key={stage.key}>
                <div style={statusDot(active, false)} title={stage.label} />
                {i < stages.length - 1 && <div style={statusLine(active)} />}
              </React.Fragment>
            );
          })}
          {order?.status !== "paid" && (
            <>
              <div style={statusLine(false)} />
              <div style={statusDot(isRejected, true)} title="Rejected" />
            </>
          )}
        </div>
        <div style={{ display: "flex", justifyContent: "space-between", flexWrap: "wrap" }}>
          {stages.map((stage) => {
            const stageData = order?.[stage.key]?.[0];
            const shortLabel = isMobile ? stage.label.substring(0, 4) : stage.label;
            return (
              <div key={stage.key} style={{ textAlign: "center", flex: 1, minWidth: isMobile ? "32px" : "50px" }}>
                <div style={{ fontSize: isMobile ? "0.6rem" : "0.90rem", fontWeight: 600, color: stageData?.status ? "#16a34a" : "#9ca3af", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }} title={stage.label}>{shortLabel}</div>
                <div style={{ fontSize: isMobile ? "0.48rem" : "0.6rem", color: "#9ca3af" }}>{stageData?.status ? moment(stageData.date).format(isMobile ? "D/M" : "MMM Do YY") : "—"}</div>
              </div>
            );
          })}
          {order?.status !== "paid" && (
            <div
              style={{ textAlign: "center", flex: 1, minWidth: isMobile ? "32px" : "50px", cursor: isRejected ? "pointer" : "default" }}
              onClick={() => {
                if (isRejected) { setMessageEditDetailed(order); setOpenMessageModal(true); }
              }}
            >
              <div style={{ fontSize: isMobile ? "0.6rem" : "0.75rem", fontWeight: 600, color: isRejected ? "#ef4444" : "#9ca3af" }}>{isMobile ? "Rej." : "Rejected"}</div>
              <div style={{ fontSize: isMobile ? "0.48rem" : "0.75rem", color: isRejected ? "#ef4444" : "#9ca3af" }}>{isRejected ? moment(order.rejected[0].date).format(isMobile ? "D/M" : "MMM Do YY") : "—"}</div>
              {isRejected && (
                <div style={{ fontSize: isMobile ? "0.55rem" : "0.75rem", color: "#ef4444", display: "flex", alignItems: "center", justifyContent: "center", gap: "0.2rem", marginTop: "0.15rem" }}>
                  <TbMessageCircle /> {isMobile ? "" : "Read"}
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    );
  };

  const renderOrderDropdown = (order) => {
    const isThisExpanded = expandedOrderId === order?._id;
    const data = isThisExpanded ? orderDetailed : null;

    if (!isThisExpanded) return null;

    return (
      <div style={dropdownBody}>
        {isLoading && !data ? (
          <div style={{ textAlign: "center", padding: "1.5rem" }}><Loader /></div>
        ) : data ? (
          <div>
            {/* Personal Information */}
            <div style={{ marginBottom: "1.25rem" }}>
              <div style={sectionTitle}><FaFileAlt style={{ color: "#6366f1" }} /> Personal Information</div>
              <div style={fieldRowThree}>
                <FieldItem label="Full Name" value={user?.name} />
                <FieldItem label="Date of Birth" value={data?.dateOfBirth} />
                <FieldItem label="Age" value={data?.age} />
              </div>
              <div style={fieldRowThree}>
                <FieldItem label="SSNIT" value={data?.ssnit} />
                <FieldItem label="ID Type" value={data?.IdCardType} />
                <FieldItem label="ID Number" value={data?.IDCardNumber} />
              </div>
              <div style={fieldRow}>
                <FieldItem label="Residential Address" value={[data?.residential_address1, data?.residential_address2].filter(Boolean).join(", ")} />
                <FieldItem label="Work Address" value={[data?.work_address1, data?.work_address2].filter(Boolean).join(", ")} />
              </div>
              <div style={fieldRowThree}>
                <FieldItem label="Phone" value={data?.personal_phone} />
                <FieldItem label="Work Phone" value={data?.work_phone} />
                <FieldItem label="Email" value={data?.email} />
              </div>
            </div>

            {/* Guarantor 1 */}
            <div style={{ marginBottom: "1.25rem" }}>
              <div style={sectionTitle}><FaUserTie style={{ color: "#6366f1" }} /> Guarantor 1</div>
              <div style={fieldRowThree}>
                <FieldItem label="Name" value={data?.guarantor_name} />
                <FieldItem label="Staff ID" value={data?.guarantor_staff_id} />
                <FieldItem label="Phone" value={data?.guarantor_phone} />
              </div>
              <div style={fieldRowThree}>
                <FieldItem label="Ghana Card" value={data?.guarantor_ghana_card} />
                <FieldItem label="GPS Address" value={data?.guarantor_gps} />
                <FieldItem label="Occupation" value={data?.guarantor_occupation} />
              </div>
              <div style={fieldRowThree}>
                <FieldItem label="Mandate Number" value={data?.guarantor_mandate_number} />
                <FieldItem label="OTP Number" value={data?.guarantor_otp_number} />
                <FieldItem label="Relationship" value={data?.guarantor_relationship} />
              </div>
            </div>

            {/* Guarantor 2 */}
            {data?.guarantor_name2 && (
              <div style={{ marginBottom: "1.25rem" }}>
                <div style={sectionTitle}><FaUserTie style={{ color: "#6366f1" }} /> Guarantor 2</div>
                <div style={fieldRowThree}>
                  <FieldItem label="Name" value={data?.guarantor_name2} />
                  <FieldItem label="Staff ID" value={data?.guarantor_staff_id2} />
                  <FieldItem label="Phone" value={data?.guarantor_phone2} />
                </div>
                <div style={fieldRowThree}>
                  <FieldItem label="Ghana Card" value={data?.guarantor_ghana_card2} />
                  <FieldItem label="GPS Address" value={data?.guarantor_gps2} />
                  <FieldItem label="Occupation" value={data?.guarantor_occupation2} />
                </div>
                <div style={fieldRowThree}>
                  <FieldItem label="Mandate Number" value={data?.guarantor_mandate_number2} />
                  <FieldItem label="OTP Number" value={data?.guarantor_otp_number2} />
                  <FieldItem label="Relationship" value={data?.guarantor_relationship2} />
                </div>
              </div>
            )}

            {/* Employment */}
            <div style={{ marginBottom: "1.25rem" }}>
              <div style={sectionTitle}><FaBriefcase style={{ color: "#6366f1" }} /> Employment Details</div>
              <div style={fieldRowThree}>
                <FieldItem label="Employer" value={data?.employer_name} />
                <FieldItem label="Facility" value={data?.facility} />
                <FieldItem label="Staff ID" value={data?.staff_id} />
              </div>
              <div style={fieldRow}>
                <FieldItem label="Sector" value={data?.sector} />
                <FieldItem label="Region" value={data?.region} />
              </div>
            </div>

            {/* Order Details */}
            <div style={{ marginBottom: "1.25rem" }}>
              <div style={sectionTitle}><FaShoppingBag style={{ color: "#6366f1" }} /> Order Details</div>
              <div style={fieldRowThree}>
                <FieldItem label="Mandate Number" value={data?.mandateNumber} />
                <FieldItem label="OTP Number" value={data?.otpNumber} />
                <FieldItem label="Monthly Deduction" value={data?.monthlyDeduction ? `GH₵ ${data.monthlyDeduction}` : "N/A"} />
              </div>
              {data?.products && data.products.length > 0 && (
                <div style={{ marginTop: "0.75rem" }}>
                  <div style={{ ...fieldLabel, marginBottom: "0.5rem" }}>Products</div>
                  <div style={{ display: "grid", gap: "0.5rem" }}>
                    {data.products.map((product, i) => (
                      <div
                        key={i}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "0.75rem",
                          padding: "0.5rem",
                          background: "#fff",
                          borderRadius: "0.4rem",
                          border: "1px solid #e5e7eb",
                        }}
                      >
                        {product?.product_id?.coverImage && (
                          <img
                            src={product.product_id.coverImage}
                            alt={product.product_id.name}
                            style={{ width: "50px", height: "50px", borderRadius: "0.3rem", objectFit: "cover" }}
                          />
                        )}
                        <div style={{ flex: 1 }}>
                          <div style={{ fontSize: "0.82rem", fontWeight: 600, color: "#1f2937" }}>
                            {product?.product_id?.name || "Product"}
                          </div>
                          <div style={{ fontSize: "0.72rem", color: "#6b7280" }}>
                            Qty: {product?.quantity || 1}
                            {product?.product_id?.price && ` | GH₵ ${product.product_id.price}`}
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>

            {/* Bank Details */}
            <div style={{ marginBottom: "1.25rem" }}>
              <div style={sectionTitle}><FaBriefcase style={{ color: "#6366f1" }} /> Bank Details</div>
              <div style={fieldRow}>
                <FieldItem label="Account Holder" value={data?.bank_account_holder_name} />
                <FieldItem label="Bank Name" value={data?.bank_name} />
              </div>
              <div style={fieldRow}>
                <FieldItem label="Account Number" value={data?.bank_account_number} />
                <FieldItem label="Branch" value={data?.bank_branch} />
              </div>
            </div>

            {/* ID Card Images */}
            {(data?.frontIDImage || data?.passportImage) && (
              <div style={{ marginBottom: "1rem" }}>
                <div style={sectionTitle}><FaIdCard style={{ color: "#6366f1" }} /> Uploaded Documents</div>
                <div style={{ display: "grid", gridTemplateColumns: isMobile ? "1fr" : "1fr 1fr", gap: "0.75rem" }}>
                  {data?.frontIDImage && (
                    <div>
                      <div style={fieldLabel}>Ghana Card (Front)</div>
                      <div style={{ borderRadius: "0.5rem", border: "1px solid #e5e7eb", overflow: "hidden", height: "160px", background: "#fff" }}>
                        <img src={data.frontIDImage} alt="Front ID" style={{ width: "100%", height: "100%", objectFit: "contain" }} />
                      </div>
                    </div>
                  )}
                  {data?.passportImage && (
                    <div>
                      <div style={fieldLabel}>Ghana Card (Back)</div>
                      <div style={{ borderRadius: "0.5rem", border: "1px solid #e5e7eb", overflow: "hidden", height: "160px", background: "#fff" }}>
                        <img src={data.passportImage} alt="Back" style={{ width: "100%", height: "100%", objectFit: "contain" }} />
                      </div>
                    </div>
                  )}
                </div>
              </div>
            )}

            {/* Collapse button */}
            <div style={{ display: "flex", justifyContent: "center", marginTop: "0.75rem" }}>
              <button
                type="button"
                onClick={() => setExpandedOrderId(null)}
                style={{ padding: "0.45rem 1.5rem", background: "#e5e7eb", color: "#374151", border: "none", borderRadius: "0.4rem", cursor: "pointer", fontWeight: 500, fontSize: "0.8rem", display: "flex", alignItems: "center", gap: "0.3rem" }}
              >
                <FaChevronUp /> Collapse
              </button>
            </div>
          </div>
        ) : (
          <div style={{ textAlign: "center", padding: "1.5rem", color: "#9ca3af" }}>No order data available</div>
        )}
      </div>
    );
  };

  return (
    <div className="MyOrdersNdPurchases">
      <RenderHome>
        {isLoading && <Loader />}
        <div style={{ maxWidth: "2000px", margin: "0 auto", padding: "1rem" }}>
          <h3 style={{ fontSize: "1.4rem", fontWeight: 700, color: "#1f2937", marginBottom: "1.25rem" }}>
            My Orders
          </h3>

          {orders?.length > 0 ? (
            <div>
              {orders?.map((order, index) => {
                const isExpanded = expandedOrderId === order?._id;
                const isRejectedWithEdit = order?.rejected?.[0]?.status && (
                  order?.rejected?.[0]?.editFormChecked ||
                  order?.rejected?.[0]?.editFormAndProductChecked
                );
                return (
                  <div key={index} style={cardStyle}>
                    <div style={cardHeader}>
                      {/* Header row */}
                      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "1rem", flexWrap: "wrap", gap: "0.5rem" }}>
                        <div>
                          <div style={{ fontSize: "0.7rem", color: "#6b7280", textTransform: "uppercase", marginBottom: "0.15rem" }}>Order #{index + 1}</div>
                          <div style={{ fontSize: "0.85rem", fontWeight: 600, color: "#1f2937" }}>
                            {order?.submitted?.[0]?.status ? moment(order?.submitted?.[0]?.date).format("MMMM Do, YYYY") : "Pending"}
                          </div>
                        </div>
                        <button
                          type="button"
                          onClick={() => {
                            if (isRejectedWithEdit) {
                              history.push({ pathname: "/edit-order-form", search: `?order_id=${order?._id}` });
                            } else {
                              handleTogglePreview(order?._id);
                            }
                          }}
                          style={isRejectedWithEdit
                            ? { ...toggleBtnStyle(false), background: "#dc2626" }
                            : toggleBtnStyle(isExpanded)}
                        >
                          {isRejectedWithEdit ? null : (isExpanded ? <FaChevronUp /> : <FaChevronDown />)}
                          {isRejectedWithEdit ? "Edit Rejected Application" : (isExpanded ? "Hide" : "Preview")}
                        </button>
                      </div>
                      {/* Status tracker */}
                      {renderStatusTracker(order)}
                    </div>

                    {/* Expandable dropdown */}
                    {renderOrderDropdown(order)}
                  </div>
                );
              })}
            </div>
          ) : (
            <NotFoundComponent title={"No orders available"} />
          )}
        </div>

        {/* Rejection Message Modal */}
        {openMessageModal && (
          <Modal
            title={"Rejected Message"}
            width={isMobile ? "85%" : "35%"}
            closeModal={setOpenMessageModal}
          >
            <div className="modalBody">
              <div className="message">
                <p>{messageEditDetailed?.rejected[0]?.message}</p>
                {(messageEditDetailed?.rejected[0]?.editFormChecked ||
                  messageEditDetailed?.rejected[0]?.editFormAndProductChecked) && (
                  <button
                    onClick={() =>
                      history.push({
                        pathname: "/edit-order-form",
                        search: `?order_id=${messageEditDetailed?._id}`,
                      })
                    }
                    type="button"
                    className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 mr-2 mb-2 mt-4 dark:bg-blue-600 dark:hover:bg-blue-700 focus:outline-none dark:focus:ring-blue-800"
                  >
                    Click here to edit form
                  </button>
                )}
              </div>
            </div>
            <div className="modalButton">
              <div className="btnCover">
                <button type="button" onClick={() => setOpenMessageModal(false)} className="cancelBtn">Close</button>
              </div>
            </div>
          </Modal>
        )}
      </RenderHome>
      <ToastContainer autoClose={3000} />
    </div>
  );
}

export default MyOrdersNdPurchases;
